module.exports = __webpack_public_path__ + "static/img/donwload_googlePlay.7d1fe10.svg";